// import { IoLocationSharp } from "react-icons/io5";
import { IoTime } from "react-icons/io5";
import { AiOutlineClose } from "react-icons/ai";
import { AiFillCalendar } from "react-icons/ai";
import { AiFillTrophy } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { RiWhatsappFill } from "react-icons/ri";
import React, { useState, useRef } from "react";
import "./Modal.css";
import { Zoom } from "react-awesome-reveal";
import { useAuth } from "../../Context/authContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//firebase
import {
  collection,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  setDoc,
} from "firebase/firestore";
import { auth } from "../../Firebase";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Modal = ({ data, closeModal, eventid }) => {
  const navigate = useNavigate();
  const { userid, currentUser } = useAuth();
  async function handleUserWhilePay() {
    // console.log(typeof(userid));
    // console.log(userid);
    const db = getFirestore();
    const docRef = doc(db, "UID", userid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      await setDoc(
        doc(db, `Participant/${docSnap.data().uid}/events`, data.name),
        {
          payment: true,
          report: false,
          signature: "NIL",
          teamMembers: team,
          //
        }
      ).then(async () => {
        await setDoc(
          doc(db, `EventList/${data.name}/List`, docSnap.data().uid),
          {
            flag: docSnap.data().uid,
          }
        );
      });
      // Event Participant List

      // console.log("Document data:", docSnap.data().uid);
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  }

  const [paymentSuccess, setPaymentSuccess] = useState(false);
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay(order) {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // creating a new order

    // Getting the order details back

    const options = {
      key: "rzp_live_BrLSTb0WYj6jhq", // Enter the Key ID generated from the Dashboard
      amount: order.amount.toString(),
      currency: "INR",
      name: "Aerophilia 2022",
      description: " ",
      image: " ",
      order_id: order.id,
      handler: async function (response) {
        const data = {
          //data?
          orderCreationId: order.id,
          ...response,
          userId: userid,
        };

        axios
          .post(`https://aerobackend.vercel.app/api/payment/verify`, data)
          .then((result) => {
            if (result.data.signatureIsValid === "true") handleUserWhilePay();
            setPaymentSuccess(true);
            toast.success("Registration Successful");
          });
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  /*----REGISTER IMPLEMENTATION-------- */
  const [drop, setDrop] = useState(false);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [count, setCount] = useState(1);
  const [team, setTeam] = useState({
    "Member 1": "",
  });
  useEffect(() => {
    setTimeout(() => {
      setOpen(false);
    }, 5000);
  }, [open]);

  const bottomRef = useRef();
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // console.log("hi");
  }, [drop]);

  const handleRegister = async () => {
    if (!currentUser) {
      navigate("/login");
    } else {
      if (data.subtype == "solo") {
        let order = await axios.post(
          `https://aerobackend.vercel.app/api/create/orderid`,
          {
            name: data.name,
          }
        );

        displayRazorpay(order.data);
      } else {
        setDrop(true);
        setVisible(false);
      }
    }
  };

  const handleChange = (e) => {
    setTeam({
      ...team,
      [e.target.name]: e.target.value,
    });
  };

  const increaseCount = (e) => {
    setTeam({
      ...team,
      [`Member ${count + 1}`]: "",
    });
    setCount(count + 1);
  };
  const decreaseCount = (e) => {
    const newTeam = team;
    if (count > 1) {
      delete newTeam[`Member ${count}`];
      setTeam(newTeam);
      setCount(count - 1);
    }
  };

  const proceedPay = async (e) => {
    setOpen(true);
    setMessage("Redirecting to Payment Gateway!");
    e.preventDefault();
    let order = await axios.post(
      `https://aerobackend.vercel.app/api/create/orderid`,
      {
        name: data.name,
      }
    );

    displayRazorpay(order.data);
  };

  return (
    <div className="overlay">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* <div>payment Status : {paymentSuccess ? "success" : "failed"}</div> */}
      {/*= U can manage payment status by paymentSuccess State */}
      <Zoom className="zoom-out" duration={500}>
        <div className="modal-container">
          <div className="modal-content">
            <div className="modal-fixed">
              <div id="head">
                <h5>{data.name}</h5>
                <div>
                  <AiOutlineClose
                    onClick={() => closeModal(false)}
                    className="closeres"
                  />
                </div>
              </div>
              <div className="info">
                <div>
                  <img src={data.image} className="img" alt="" />
                </div>

                <div className="quick-info">
                  <div>
                    <AiFillTrophy /> <h2>{data.prize}</h2>
                  </div>
                  {/* <div>
                    <IoLocationSharp /> <h2>{data.venue}</h2>
                  </div> */}
                  <div>
                    <AiFillCalendar /> <h2> {data.date}</h2>
                  </div>
                  <div>
                    <IoTime/>
                    <h2>{data.time}</h2>
                  </div>
                </div>
                <div className="contact-info">
                  <h2>ORGANIZER DETAILS:</h2>

                  {data.contactDetails.map((e, i) => (
                    <div key={i} className="organiser">
                      <div>
                        <BsFillPersonFill /> <span>{e.name}</span>
                      </div>
                      <div className="tele">
                        <RiWhatsappFill />
                        <span>
                          <a
                            href={`https://api.whatsapp.com/send?phone=${e.phoneNumber}`}
                          >
                            +91 {e.phoneNumber}
                          </a>
                        </span>
                      </div>
                    </div>
                  ))}

                  {data.faq && (
                    <div>
                      <h2
                        className="faq"
                        style={{
                          color: "red",
                          marginTop: "0px",
                          paddingTop: "15px",
                        }}
                      >
                        {data.faq}
                      </h2>
                      <span>{data.faqDetail}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-relative">
              <AiOutlineClose
                onClick={() => closeModal(false)}
                className="close"
              />

              <div>
                <h5>DESCRIPTION:</h5>
                <p>{data.desc}</p>
              </div>
              {data.rules && (
                <div className="">
                  <h5>RULES:</h5>
                  <p className=" ">
                    <ul>
                      {data.rules.map((value, index) => (
                        <li key={index}>{value}</li>
                      ))}
                    </ul>
                  </p>
                </div>
              )}
              {data.registrations && (
                <div className="">
                  <h5>REGISTRATION DETAILS:</h5>
                  <p className=" ">
                    <ul>
                      {data.registrations.map((value, index) => (
                        <li key={index}>{value}</li>
                      ))}
                    </ul>
                  </p>
                </div>
              )}
              {data.teamReq && (
                <div className="">
                  <h5>TEAM REQUIREMENTS:</h5>
                  <p className="   ">
                    <ul className=" ">
                      {data.teamReq.map((value, index) => (
                        <li key={index}>{value}</li>
                      ))}
                    </ul>
                  </p>
                </div>
              )}
              {data.judgingCriteria && (
                <div className="">
                  <h5>JUDGING CRITERIA:</h5>
                  <p className="   ">
                    <ul className=" ">
                      {data.judgingCriteria.map((value, index) => (
                        <li key={index}>{value}</li>
                      ))}
                    </ul>
                  </p>
                </div>
              )}

              {data.format && (
                <div>
                  <h5>FORMAT:</h5>
                  {Object.keys(data.format).map((key, index) => {
                    return (
                      <div key={index} className="round">
                        {key && <h4>{key}</h4>}
                        <p>
                          <ul>
                            {data.format[key].map((value, index) => (
                              <li key={index}>{value}</li>
                            ))}
                          </ul>
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}

              <div className="note">
                <p>
                  <span>NOTE:</span>Rules are subjected to change.
                </p>
              </div>

              <div className="buttons">
               {data.link && (
                <div>
                  <a href={data.link} target="_blank">
                    <button className="button-62">Download Rulebook</button>
                  </a>
                </div> 
               )}
                <div>
                  {data.mode == "online" && visible && (
                    <button className="button-62" onClick={handleRegister}>
                      Click here to register
                    </button>
                  )}
                </div>
              </div>
              {drop && (
                <React.Fragment>
                  <div className="drop-container">
                    <h1
                      className="drop-head"
                      style={{ color: "rgba(250, 163, 76, 0.982)" }}
                    >
                      TEAM DETAILS
                    </h1>
                    <form className="sign-form">
                      {Object.keys(team).map((key, index) => {
                        return (
                          <input
                            type="text"
                            key={key}
                            name={key}
                            className="input-field"
                            placeholder={`Member ${index + 1}`}
                            onChange={handleChange}
                            required
                          />
                        );
                      })}
                      {open && (
                        <div
                          className="note"
                          style={{
                            marginTop: "1rem",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span
                            style={{
                              textAlign: "center",
                              fontWeight: "100",
                              fontSize: "1rem",
                            }}
                          >
                            {message}
                          </span>
                        </div>
                      )}
                    </form>
                    <div className="button-list">
                      {count < data.maxlimit ? (
                        <button
                          className="button-62"
                          onClick={(e) => increaseCount(e)}
                        >
                          Add Member
                        </button>
                      ) : (
                        <button className="button-62">Max limit reached</button>
                      )}
                      <button
                        className="button-62"
                        onClick={(e) => decreaseCount(e)}
                      >
                        Remove Member
                      </button>
                      <button
                        className="button-62"
                        id="rzp-button1"
                        onClick={(e) => proceedPay(e)}
                      >
                        Proceed to Pay
                      </button>

                      {/* Loading and error message */}

                      {/* {console.log(count)} */}
                    </div>
                  </div>
                  <div ref={bottomRef}></div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </Zoom>
    </div>
  );
};

export default Modal;
